import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import EditStayRulesModal from "./EditStayRulesModal";

const PropertySettingsModal = ({ onClose }) => {
  const [openEditModal, setOpenEditModal] = useState(false);

  if (openEditModal) {
    return <EditStayRulesModal onClose={() => setOpenEditModal(false)} />;
  }

  return (
    <Container>
      <div className="flex items-center justify-between bg-[#0078BD] py-6 px-4">
        <Title className="text-white">Property Settings</Title>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </div>

      {/* <div className="px-6 h-full flex flex-col justify-between py-4 relative">
        <Wrapper>
          <Section>
            <SectionTitle>Renting Terms</SectionTitle>
            <Row>
              <Label>Rent Addition Cycle</Label>
              <Value>1st of month</Value>
            </Row>
          </Section>

          <Section>
            <SectionTitle>Stay Terms</SectionTitle>
            <Row>
              <Label>Days In Month</Label>
              <Value>As per month</Value>
            </Row>
            <Row>
              <Label>Daily Charges</Label>
              <Value>₹500</Value>
            </Row>
            <Row>
              <Label>Lock-in Period</Label>
              <Value>1 Month</Value>
            </Row>
            <Row>
              <Label>Notice Period</Label>
              <Value>30 Days</Value>
            </Row>
            <Row>
              <Label>Agreement Duration</Label>
              <Value>11 Months</Value>
            </Row>
            <Row>
              <Label>Check-in Time</Label>
              <Value>--</Value>
            </Row>
            <Row>
              <Label>Check-out Time</Label>
              <Value>--</Value>
            </Row>
          </Section>
        </Wrapper>

        <BtnWrapper>
          <SecondaryButton>Copy settings to other properties</SecondaryButton>
          <PrimaryButton onClick={() => setOpenEditModal(true)}>
            Edit
          </PrimaryButton>
        </BtnWrapper>
      </div> */}
    </Container>
  );
};

const Wrapper = tw.div`grid gap-2 my-2`;
const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-gray-800`;
const Section = tw.div``;
const SectionTitle = tw.h2`text-lg font-semibold text-gray-700 mb-2`;
const Row = tw.div`flex justify-between p-2 `;
const Label = tw.label`text-sm text-gray-500 font-normal`;
const Value = tw.span`text-gray-800 font-medium`;
const BtnWrapper = tw.div`flex flex-col sm:flex-row gap-3 w-full sm:justify-between mt-4 `;
const PrimaryButton = tw.button`bg-[#0078BD] w-full sm:w-1/2 md:w-2/5 lg:w-1/3 text-white p-2 rounded-lg hover:bg-[#65adf0]`;
const SecondaryButton = tw.button`bg-white border w-full sm:w-1/2 md:w-3/5 lg:w-2/3 border-[#0078BD] text-[#0078BD] font-medium lg:py-1 p-2 rounded-lg`;

export default PropertySettingsModal;
